import FnrTypography from "FnrTypography/FnrTypography";

import FnrDivider from "UI/FnrDivider/FnrDivider";
import FnrIcon from "UI/FnrIcon/FnrIcon";

import extendedFieldInputContainers from "../containers";

import EditSelector from "./EditSelector";
import ViewSelector from "./ViewSelector";

const { SFnrCard, VerticallyCentered, IconContainer } =
  extendedFieldInputContainers;

const PrivilegeLevel = () => (
  <SFnrCard data-cy="ExtendedFields_PrivilegeLevel">
    <VerticallyCentered>
      <IconContainer $view>
        <FnrIcon icon="fa-eye far" />
      </IconContainer>
      <ViewSelector />
    </VerticallyCentered>
    <FnrDivider $color="fnMediumGrey" />
    <VerticallyCentered>
      <IconContainer $color="purple">
        <FnrIcon icon="fa-pencil far" />
      </IconContainer>
      <EditSelector />
    </VerticallyCentered>
    <FnrDivider />
    <FnrTypography color="textSecondary" fontSize="sm">
      Note: Super Admins can view and edit all profile fields, even on their own
      profile.
    </FnrTypography>
  </SFnrCard>
);

export default PrivilegeLevel;
